import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { customTranslationsStateSelector } from '~/selectors';

import { CustomTranslations } from './types';

export const useCustomTranslations = (): {
  customTranslations: CustomTranslations;
  hasData: boolean;
  isLoading: boolean;
  failedToLoad: boolean;
} => {
  return useSelector((state: StoreState) => {
    return customTranslationsStateSelector(state);
  });
};
